import { ReactNode } from 'react';
import Container from '../container';
import BackofficeSidebar from '../BackofficeSidebar';
import GeneralContainerView from '../generalContainerView';
import Header from '../header/Header';
import ModuleView from '../moduleView';

interface IButton {
  title?: string;
  route?: string;
  color?: string;
  icon?: ReactNode;
  action?: () => void;
  identifiacator?: string;
}

interface IHeaderInfo {
  title: string;
  subtitle: string;
  titleRoute?: string;
  searchbarPlaceholder?: string;
}

interface ISideBar {
  position: string;
}
interface ISharedModules {
  title: string;
  key: number;
  active: boolean;
}

interface IButtons {
  buttons?: IButton[];
  children: ReactNode;
  headerInfo?: IHeaderInfo;
  infoSideBar?: ISideBar;
  viewSearchBar?: boolean;
  searchBarDropdownList?: JSX.Element;
  searchText?: string;
  searchbarPlaceholder?: string;
  setSearchText?: (text: string) => void;
  buttonDisabled?: boolean;
  sharedModules?: ISharedModules[];
  sharedModule?: ISharedModules;
  sharedModulesAction?: (key: number) => void;
  loadingSearchBar?: boolean;
  customClassNameButtonMenu?: string;
  custonMarginRightButtonsContainer?: string;
}

const ChargerModule = ({
  children,
  buttons,
  headerInfo,
  infoSideBar,
  viewSearchBar,
  searchBarDropdownList,
  searchText,
  searchbarPlaceholder,
  setSearchText,
  buttonDisabled,
  sharedModules,
  sharedModule,
  sharedModulesAction,
  loadingSearchBar,
  customClassNameButtonMenu = '',
  custonMarginRightButtonsContainer = ''
}: IButtons) => {
  return (
    <Container>
      <Header
        buttonsHeader={buttons}
        headerInfo={headerInfo}
        viewSearchBar={viewSearchBar}
        searchBarDropdownList={searchBarDropdownList}
        searchbarPlaceholder={searchbarPlaceholder}
        searchText={searchText}
        setSearchText={setSearchText}
        buttonDisabled={buttonDisabled}
        sharedModules={sharedModules}
        sharedModulesAction={sharedModulesAction}
        sharedModule={sharedModule}
        loadingSearchBar={loadingSearchBar}
        customClassNameButtonMenu={customClassNameButtonMenu}
        custonMarginRightButtonsContainer={custonMarginRightButtonsContainer}
      />
      <GeneralContainerView>
        <BackofficeSidebar infoSideBar={infoSideBar} />
        <ModuleView>{children}</ModuleView>
      </GeneralContainerView>
    </Container>
  );
};

export default ChargerModule;
